<!-- payment.component.html -->
<main class="flex overflow-hidden flex-col bg-white">
  <div class="self-center w-full max-w-[1312px]">
    <div class="flex flex-col">
      <section class="w-full max-sm:mt-[10px]">
        <!-- Tab Navigation -->
        <div class="sticky top-0 z-10 bg-white">
          <div class="flex flex-col w-full bg-white">
            <div class="flex w-full border-b border-[#E5E7EB]">
              <!-- <button
                class="flex items-center gap-1 px-2 py-3 text-xs font-medium relative"
                [class.text-blue-500]="activeTab === 'home'"
                [class.text-gray-500]="activeTab !== 'home'"
                (click)="setActiveTab('home')"
              >
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/c1d155a0af8fb588c21b5410951fe052f7f5d092?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                  class="w-4 h-4"
                  alt="Home delivery icon"
                />
                <span>Home Delivery ({{ homeDeliveryProducts.length }})</span>
                <span
                  *ngIf="activeTab === 'home'"
                  class="absolute left-0 -bottom-[2px] w-full h-0.5 bg-blue-500 rounded"
                ></span>
              </button> -->
              <button class="flex items-center gap-1 px-2 py-3 text-xs font-medium relative ml-4"
                [class.text-blue-500]="activeTab === 'store'" [class.text-gray-500]="activeTab !== 'store'"
                (click)="setActiveTab('store')">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/4bd1f0d86dce552c8794774e64ba65fdce3be281?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                  class="w-4 h-4" alt="Store pickup icon" />
                <span>Store Pickup ({{ storePickupProducts.length }})</span>
                <span *ngIf="activeTab === 'store'"
                  class="absolute left-0 -bottom-[2px] w-full h-0.5 bg-blue-500 rounded"></span>
              </button>
            </div>
          </div>
        </div>

        <!-- Address Section -->
        @if (homeDeliveryProducts.length > 0) {
        <div class="px-4 py-3 mt-3 bg-gray-50" *ngIf="activeTab === 'home'">
          <div class="flex flex-col">
            <div class="flex items-center gap-2">
              <p class="text-sm font-bold text-[#0A0A5F]">
                {{ "Home Delivery at:" }}
              </p>
              <p class="text-sm font-medium">
                {{ userData?.shipping_address?.receiver_name }}
              </p>
              <p class="text-sm font-medium">
                {{ userData?.shipping_address?.pincode }}
              </p>
              <span *ngIf="userData?.shipping_address?.address_type"
                class="px-2 py-0.5 text-xs bg-white rounded text-gray-500">
                {{ userData?.shipping_address?.address_type }}
              </span>
            </div>
            <p class="mt-1 text-sm text-gray-500">
              {{ userData?.shipping_address?.address_1 }}
              <span *ngIf="userData?.shipping_address?.city">,{{ userData?.shipping_address?.city }}</span>
              <span *ngIf="userData?.shipping_address?.state">,{{ userData?.shipping_address?.state }}</span>
              <span *ngIf="userData?.shipping_address?.state">,{{ userData?.shipping_address?.state }},</span>
              <span *ngIf="userData?.shipping_address?.pincode">{{
                userData?.shipping_address?.pincode
                }}</span>
            </p>
            <!-- <p class="mt-1 text-sm text-gray-500">
                Working Hours: Mon–Fri, 9:00 AM – 7:00 PM
              </p> -->
          </div>
        </div>

        <!-- Product List -->
        <div class="mt-2">
          <ng-container *ngIf="activeTab === 'home'">
            <article *ngFor="let product of homeDeliveryProducts"
              class="flex items-start justify-between p-4 border-b border-gray-200 relative">
              <!-- Left section -->
              <div class="flex gap-4 w-full">
                <div class="w-[110px] h-[80px] flex-shrink-0 relative">
                  <img [src]="product?.part_image_path[0]" [alt]="product?.table_name"
                    class="w-full h-full object-cover rounded-md" />
                  <!-- Quality Badge Overlay - Mobile -->
                  <div *ngIf="product?.quality_s"
                    class="absolute top-1 right-1 z-10 flex items-center gap-1 px-1 py-1 rounded max-sm:flex sm:hidden"
                    [ngClass]="
                        product?.quality_s === 'A'
                          ? 'bg-green-100 text-green-800'
                          : product?.quality_s === 'B'
                            ? 'bg-yellow-100 text-yellow-800'
                            : product?.quality_s === 'C'
                              ? 'bg-orange-100 text-orange-800'
                              : 'bg-green-100 text-green-800'
                      ">
                    <div class="flex items-center gap-1">
                      <div class="w-3 h-3 flex items-center justify-center rounded text-white text-[10px] font-bold"
                        [ngClass]="
                            product?.quality_s === 'A'
                              ? 'bg-[#01811D]'
                              : product?.quality_s === 'B'
                                ? 'bg-[#B8860B]'
                                : product?.quality_s === 'C'
                                  ? 'bg-[#D35400]'
                                  : 'bg-[#01811D]'
                          ">
                        {{ product?.quality_s }}
                      </div>
                      <span class="text-xs font-bold"> Quality </span>
                    </div>
                  </div>
                </div>

                <div class="flex flex-col flex-1 min-w-0">
                  <div *ngIf="product?.quality_s"
                    class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium w-fit mb-1 max-md:hidden"
                    [ngClass]="
                        product?.quality_s === 'A'
                          ? 'bg-green-100 text-green-800'
                          : product?.quality_s === 'B'
                            ? 'bg-yellow-100 text-yellow-800'
                            : product?.quality_s === 'C'
                              ? 'bg-orange-100 text-orange-800'
                              : 'bg-green-100 text-green-800'
                      ">
                    <svg width="14" height="14" class="mr-1">
                      <rect width="14" height="14" rx="3" [attr.fill]="
                            product?.quality_s === 'A'
                              ? '#01811D'
                              : product?.quality_s === 'B'
                                ? '#B8860B'
                                : product?.quality_s === 'C'
                                  ? '#D35400'
                                  : '#01811D'
                          " />
                      <text [attr.x]="7" [attr.y]="10" text-anchor="middle" font-size="9"
                        font-family="Arial, sans-serif" fill="white">
                        {{ product.quality_s }}
                      </text>
                    </svg>
                    Quality
                  </div>

                  <h3 class="text-sm font-semibold text-gray-900 line-clamp-1">
                    {{ product?.table_name }}
                  </h3>

                  <div class="text-xs text-gray-600 mt-0.5">
                    <span *ngIf="product?.make">{{ product?.make }} • </span>
                    <span *ngIf="product?.model">{{ product?.model }} •
                    </span>
                    <span *ngIf="product?.year_of_manufacture">{{
                      product?.year_of_manufacture
                      }}</span>
                    <span *ngIf="product?.fuel_type">
                      • {{ product?.fuel_type }}</span>
                  </div>

                  <div class="mt-1 text-xs">
                    <span class="text-gray-500">Sold by:</span>
                    <span class="font-semibold text-black">
                      {{ product?.seller_detail?.seller_name }}
                    </span>
                  </div>

                  <div class="mt-1 text-xs block sm:hidden">
                    <span class="text-gray-500"> Get Delivery by</span>
                    <span class="font-medium text-gray-900">
                      {{
                      product?.delivery_date ||
                      (product?.updated_at_dt | date: "dd MMM")
                      }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Delivery Date -->
              <div class="absolute top-4 right-4 text-xs text-gray-500 hidden sm:block">
                Get Delivery by
                <span class="font-medium text-gray-900">
                  {{
                  product?.delivery_date ||
                  (product?.updated_at_dt | date: "dd MMM")
                  }}
                </span>
              </div>
            </article>
          </ng-container>
        </div>
        }

        <div class="px-4 py-3 mt-3 bg-gray-50" *ngIf="storePickupProducts.length > 0">
          <div class="flex flex-col">
            <div class="flex items-center gap-2">
              <p class="text-sm font-bold text-[#0A0A5F]">
                {{ "Store Pickup at:" }}
              </p>
              <p class="text-sm font-medium">
                {{ storePickupProducts[0]?.seller_detail?.seller_name }}
              </p>
              <p class="text-sm font-medium">
                {{ storePickupProducts[0]?.seller_detail?.pincode }}
              </p>
              <!-- <span
                  *ngIf="storePickupProducts[0]?.seller_detail?.branch_name"
                  class="px-2 py-0.5 text-xs bg-white rounded text-gray-500"
                >
                  {{ 'Store' }}
                </span> -->
            </div>
            <p class="mt-1 text-sm text-gray-500">
              {{ storePickupProducts[0]?.seller_detail?.address_1 }}
              <span *ngIf="storePickupProducts[0]?.seller_detail?.city">,{{ storePickupProducts[0]?.seller_detail?.city
                }}</span>
              <span *ngIf="storePickupProducts[0]?.seller_detail?.state">,{{
                storePickupProducts[0]?.seller_detail?.state }}</span>
              <span *ngIf="storePickupProducts[0]?.seller_detail?.state">,{{
                storePickupProducts[0]?.seller_detail?.state }},</span>
              <span *ngIf="storePickupProducts[0]?.seller_detail?.pincode">{{
                storePickupProducts[0]?.seller_detail?.pincode
                }}</span>
            </p>
            <!-- <p *ngIf="activeTab === 'store'" class="mt-1 text-sm text-gray-500">
                Working Hours: Mon–Fri, 9:00 AM – 7:00 PM
              </p> -->
          </div>
        </div>

        <!-- Product List -->
        <div class="mt-2">
          <ng-container>
            <article *ngFor="let product of storePickupProducts"
              class="relative flex items-start justify-between p-4 border-b border-gray-200">
              <!-- Left section -->
              <div class="flex gap-4 w-full">
                <!-- Image -->
                <div class="w-[100px] h-[80px] flex-shrink-0 max-md:w-[80px] max-md:h-[80px] relative">
                  <img [src]="product?.part_image_path[0]" [alt]="product?.table_name"
                    class="w-full h-full object-cover rounded-md" />
                  <!-- Quality Badge Overlay - Mobile -->
                  <div *ngIf="product?.quality_s"
                    class="absolute top-1 right-1 z-10 flex items-center gap-1 px-2 py-1 rounded max-sm:flex sm:hidden"
                    [ngClass]="
                      product?.quality_s === 'A'
                        ? 'bg-[#90EE90]'
                        : product?.quality_s === 'B'
                          ? 'bg-[#FFE4B5]'
                          : product?.quality_s === 'C'
                            ? 'bg-[#FFA07A]'
                            : 'bg-[#90EE90]'
                    ">
                    <div class="flex items-center gap-1">
                      <div class="w-4 h-4 flex items-center justify-center rounded text-white text-xs font-bold"
                        [ngClass]="
                          product?.quality_s === 'A'
                            ? 'bg-[#01811D]'
                            : product?.quality_s === 'B'
                              ? 'bg-[#B8860B]'
                              : product?.quality_s === 'C'
                                ? 'bg-[#D35400]'
                                : 'bg-[#01811D]'
                        ">
                        {{ product?.quality_s }}
                      </div>
                      <span class="text-xs font-bold" [ngClass]="
                          product?.quality_s === 'A'
                            ? 'text-[#01811D]'
                            : product?.quality_s === 'B'
                              ? 'text-[#B8860B]'
                              : product?.quality_s === 'C'
                                ? 'text-[#D35400]'
                                : 'text-[#01811D]'
                        ">
                        Quality
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Product Info -->
                <div class="flex flex-col flex-1 min-w-0">
                  <!-- Quality Badge -->
                  <div *ngIf="product?.quality_s"
                    class="inline-flex items-center self-start px-2 py-0.5 rounded text-xs font-medium mb-1" [ngClass]="
                      product?.quality_s === 'A'
                        ? 'bg-green-100 text-green-800'
                        : product?.quality_s === 'B'
                          ? 'bg-yellow-100 text-yellow-800'
                          : product?.quality_s === 'C'
                            ? 'bg-orange-100 text-orange-800'
                            : 'bg-green-100 text-green-800'
                    ">
                    <svg width="14" height="14" class="mr-1">
                      <rect width="14" height="14" rx="3" [attr.fill]="
                          product?.quality_s === 'A'
                            ? '#01811D'
                            : product?.quality_s === 'B'
                              ? '#B8860B'
                              : product?.quality_s === 'C'
                                ? '#D35400'
                                : '#01811D'
                        " />
                      <text [attr.x]="7" [attr.y]="10" text-anchor="middle" font-size="9"
                        font-family="Arial, sans-serif" fill="white">
                        {{ product.quality_s }}
                      </text>
                    </svg>
                    Quality
                  </div>

                  <!-- Title -->
                  <h3 class="text-sm font-semibold text-gray-900 line-clamp-1">
                    {{ product?.table_name }}
                  </h3>

                  <!-- Description -->
                  <div class="text-xs text-gray-600 mt-0.5">
                    <span *ngIf="product?.make">{{ product?.make }} • </span>
                    <span *ngIf="product?.model">{{ product?.model }} • </span>
                    <span *ngIf="product?.year_of_manufacture">{{
                      product?.year_of_manufacture
                      }}</span>
                  </div>
                  <div class="mt-1 text-xs">
                    <span class="text-gray-500">Quantity :</span>
                    <span class="font-semibold text-black">
                      {{ product?.total_quantity }} Kg
                    </span>
                  </div>
                  <!-- Seller -->
                  <div class="mt-1 text-xs">
                    <span class="text-gray-500">Sold by:</span>
                    <span class="font-semibold text-black">
                      {{ product?.seller_detail?.seller_name }}
                    </span>
                  </div>
                  <div class="mt-1 text-xs block sm:hidden">
                    <span class="text-gray-500">Pickup by</span>
                    <span class="font-medium text-gray-900">
                      {{
                      product?.delivery_date ||
                      (product?.updated_at_dt | date: "dd MMM")
                      }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Pickup Date -->
              <div class="absolute top-4 right-4 text-xs text-gray-500 hidden sm:block">
                Pickup by
                <span class="font-medium text-gray-900">
                  {{ product?.updated_at_dt | date: "dd MMM" }}
                </span>
              </div>
            </article>
          </ng-container>
        </div>
      </section>
    </div>
  </div>
</main>